import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Stack, Textarea } from "@mantine/core";
import { AppModal } from "./AppModal";
import { useForm, yupResolver } from "@mantine/form";
import { CharacterLimit } from "../enums/CharacterLimit";
import { useCreateBugReportMutation } from "../graphql/graphql";
import { showErrorNotification, showSuccessNotification } from "./Notifications";
import { BugReportInitialValues, BugReportSchema } from "./BugReportModal.validation";
export const BugReportModal = ({ opened, close }) => {
    const [{ fetching: submittingBugReport }, createBugReport] = useCreateBugReportMutation();
    // Form Data
    const form = useForm({
        mode: "controlled",
        initialValues: BugReportInitialValues,
        validate: yupResolver(BugReportSchema)
    });
    // Sends the bug report
    const submitBugReport = async (event) => {
        event.preventDefault();
        const valid = form.validate();
        if (valid.hasErrors)
            return;
        // Sends the bug report
        createBugReport({ message: form.values.message })
            .then(() => {
            showSuccessNotification("Bug report submitted!");
        })
            .catch((error) => {
            console.error("An error occurred.", error);
            showErrorNotification("Failed to submit bug report.... which is actually ironic... and a bug...");
        })
            .finally(() => {
            handleClose();
        });
    };
    const handleClose = () => {
        close();
        form.reset();
    };
    return (_jsx(AppModal, { title: "Submit Bug Report", opened: opened, onClose: handleClose, children: _jsxs(Stack, { gap: "md", children: [_jsx(Textarea, { label: "Bug Report", placeholder: "Please describe the bug you're experiencing... \n\n" +
                        "Please include steps to reproduce the bug, what page or feature you were on, and any other relevant information.", autosize: true, minRows: 4, maxRows: 20, maxLength: CharacterLimit.BUG_REPORT, ...form.getInputProps("message") }), _jsxs(Flex, { justify: "space-between", children: [_jsx("div", { style: {
                                color: "grey",
                                paddingLeft: "0.25rem",
                                fontSize: 12
                            }, children: `${form.values.message.length} / ${CharacterLimit.BUG_REPORT}` }), _jsx(Button, { variant: "filled", loading: submittingBugReport, onClick: submitBugReport, children: "Submit" })] })] }) }));
};
